import Vue from 'vue';
import { Carousel } from '@/components';
const ProductItem = () => import(/* webpackChunkName: "ProductItem" */ './ProductItem.vue');
export default Vue.extend({
    components: {
        Carousel,
        ProductItem,
    },
    props: {
        noTitle: {
            type: Boolean,
            default: false,
        },
        wrapperClass: {
            type: String,
            default: 'px-4 3xl:px-0 py-10 sm:py-16',
        },
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
    // itemsSample: [
    //   {
    //     name: "Belajar.id Gmail",
    //     description: "Hac pellentesque diam pulvinar.",
    //     image: require("/images/product-gmail.webp"),
    //   },
    //   {
    //     name: "Docs",
    //     description: "All your documents, editable and shareable",
    //     image: require("/images/product-docs.webp"),
    //   },
    //   {
    //     name: "Slides",
    //     description: "Tell stories with presentations you can create anywhere.",
    //     image: require("/images/product-slides.webp"),
    //   },
    //   {
    //     name: "Drive",
    //     description: "A safe place to keep, access, and share your files.",
    //     image: require("/images/product-drive.webp"),
    //   },
    //   {
    //     name: "Sheets",
    //     description: "Smart spreadsheets you can work on from anywhere.",
    //     image: require("/images/product-sheets.webp"),
    //   },
    //   {
    //     name: "Product 1",
    //     description: "Inspirasi praktik ajar yang sudah dikurasi",
    //     image: require("/images/product-assessment.webp"),
    //   },
    //   {
    //     name: "Product 2",
    //     description: "Hac pellentesque diam pulvinar.",
    //     image: require("/images/product-assessment.webp"),
    //   },
    // {
    //   name: "Product 3",
    //   description: "Hac pellentesque diam pulvinar.",
    //   image: "product-assessment.webp",
    // },
    // {
    //   name: "Product 4",
    //   description: "Hac pellentesque diam pulvinar.",
    //   image: "product-assessment.webp",
    // },
    // ],
    }),
    computed: {
        items() {
            return this.$getContent('products.items');
        },
        carouselOptions() {
            return {
                slidesPerView: 1.3,
                spaceBetween: 10,
                loop: false,
                breakpoints: {
                    640: {
                        slidesPerView: 3.3,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 4.8,
                        spaceBetween: 10,
                    },
                },
                ...this.options,
            };
        },
    },
});
